import { useAppSelector } from '../../global/hooks';
import { Modal, ModalCloseButton, ModalFoot, ModalHead, SaveButton } from '../../global/styles';
import { useAddNewArrangementMutation, useGetUserQuery } from '../../store/apiSlice';
import {
	selectActiveArrangementId,
	selectActiveArrangementName,
	selectBpm,
	selectTimeSignature,
	selectView,
	setView
} from '../../store/appSlice';
import { selectSections } from '../../store/sectionsSlice';
import SaveBody from './SaveBody';
import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useClickAway } from 'react-use';

export default function Save() {
	const dispatch = useDispatch();

	const { data: user } = useGetUserQuery();

	const sections = useAppSelector(selectSections);
	const bpm = useAppSelector(selectBpm);
	const timeSignature = useAppSelector(selectTimeSignature);

	const ref = useRef(null);
	const saveRef = useRef<HTMLButtonElement>(null);

	const arrangementName = useAppSelector(selectActiveArrangementName);
	const activeArrangementId = useAppSelector(selectActiveArrangementId);

	const isVisible = useAppSelector(selectView) === 'save';
	const closeModal = () => {
		dispatch(setView('main'));
	};

	const [saveArrangement, { status, error }] = useAddNewArrangementMutation();

	const handleSaveArrangement = () =>
		saveArrangement({
			userId: user?.id ?? 0,
			arrangement: {
				name: arrangementName ?? '',
				sections,
				bpm,
				timeSignature,
				id: activeArrangementId ? activeArrangementId : Date.now()
			}
		});

	useClickAway(ref, () => {}); //closeModal());
	return isVisible ? (
		<Modal ref={ref}>
			<ModalCloseButton
				onClick={closeModal}
				title="close this modal popup"
				aria-label="close this modal poup"
			/>

			<div>
				<ModalHead>Save Arrangement</ModalHead>
				<SaveBody saveRef={saveRef} />
			</div>

			<ModalFoot>
				<SaveButton
					ref={saveRef}
					disabled={arrangementName === ''}
					onClick={handleSaveArrangement}
					title={arrangementName !== '' ? undefined : 'No changes detected'}
				>
					Save Arrangement
				</SaveButton>
			</ModalFoot>
		</Modal>
	) : null;
}
